import type { FC, PropsWithChildren } from 'react';
import React, { useMemo, useRef } from 'react';

import type { PageSectionRefs } from './context';
import { PageSectionRefsContext } from './context';

export type PageSectionRefsProviderProps = Partial<PageSectionRefs>;

const PageSectionRefsProvider: FC<PropsWithChildren<PageSectionRefsProviderProps>> = (props) => {
  const feedRef = useRef(null);
  const pinnedThreadsRef = useRef(null);

  const { feed = feedRef, pinnedThreads = pinnedThreadsRef, children } = props;

  const value = useMemo(() => ({ feed, pinnedThreads }), [feed, pinnedThreads]);

  return <PageSectionRefsContext.Provider value={value}>{children}</PageSectionRefsContext.Provider>;
};

export default PageSectionRefsProvider;
